import { render, staticRenderFns } from "./VCompletedProposal.vue?vue&type=template&id=4888aef2&scoped=true"
import script from "./VCompletedProposal.vue?vue&type=script&lang=js"
export * from "./VCompletedProposal.vue?vue&type=script&lang=js"
import style0 from "./VCompletedProposal.vue?vue&type=style&index=0&id=4888aef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888aef2",
  null
  
)

export default component.exports